import React from 'react'
import {Footer, TopNav} from "../components";
const NewsLayout = (props) => {
    return (
        <div className="d-flex flex-column h-100">
            <TopNav/>
            <div className="flex-grow-1 pb-3">
                {props.children}
            </div>
            <Footer/>
        </div>
    )
}

export default NewsLayout